import './App.css';
import MapView from '../src/components/MapView'
import MapState from './context/MapState'
function App() {
  return (
    <MapState>
      <div className="App">
        <MapView />
      </div>
    </MapState>
  );
}

export default App;
